module.exports = __webpack_public_path__ + "3b838d2affef3273c9b4e5f79a0c752a.png";